// theme.js
import {createSystem, defaultConfig, defineConfig} from "@chakra-ui/react";

const colors = {
    primary: {
        50: "#e0f2f4",
        100: "#b3dde0",
        200: "#80c6cb",
        300: "#4cafb6",
        400: "#269aa2",
        500: "#033642",
        600: "#022f3b",
        700: "#022734",
        800: "#011f2c",
        900: "#011724",
    },
    agxes: {
        primary: "#173441",
        primaryLight: "#285061",
        secondary: "#53ab91",
        accent: "#6cdb83",
        accentLight: "#89ea9c",
        text: "#231f20",
    },
    agxesPalette: {
        50: "#e8f0f2",
        100: "#c0d5d9",
        200: "#96b8bd",
        300: "#6b9ba2",
        400: "#487f88",
        500: "#173441",
        600: "#122a36",
        700: "#0d212a",
        800: "#09171f",
        900: "#050d12",
        950: "#000000",
    },
};

const config = defineConfig({
    keyframes: {
        move1: {
            "0%, 100%": {transform: "translate(0, 1) scale(1)"},
            "50%": {transform: "translate(70px, -50px) scale(2)"},
        },
        move2: {
            "0%, 100%": {transform: "translate(0, 0) scale(1)"},
            "50%": {transform: "translate(-80px, 80px) scale(1.9)"},
        },
        move3: {
            "0%, 100%": {transform: "translate(0, 1) scale(1)"},
            "50%": {transform: "translate(70px, 0px) scale(1.8)"},
        },
    },

    animations: {
        move1: "move1 18s ease-in-out infinite",
        move2: "move2 22s ease-in-out infinite",
        move3: "move3 26s ease-in-out infinite",
    },
    globalCss: {
        html: {scrollBehavior: "smooth"},
    },
    theme: {
        keyframes: {
            move1: {
                "0%, 100%": {transform: "translate(50px, -50px) scale(1)"},
                "50%": {transform: "translate(100px, -100px) scale(1.2)"},
            },
            move2: {
                "0%, 100%": {transform: "translate(50px, -50px) scale(1)"},
                "50%": {transform: "translate(-100px, 100px) scale(1.4)"},
            },
            move3: {
                "0%, 100%": {transform: "translate(300px, 0px) scale(1)"},
                "50%": {transform: "translate(-300px, 0px) scale(1.2)"},
            },
            shakeX: {
                "0%, 100%": {transform: "translateX(-100%)"},
                "50%": {transform: "translateX(100%)"},
            },
        },
        tokens: {
            colors,
            animations: {
                move1: {value: "move1 18s ease-in-out infinite alternate"},
                move2: {value: "move2 22s ease-in-out infinite alternate"},
                move3: {value: "move3 26s ease-in-out infinite alternate"},
                shakeX: {value: "shakeX 1s ease-in-out infinite"},
            },
        },
        semanticTokens: {
            colors: {
                agxesPalette: {
                    solid: {value: "{colors.agxes.500}"},
                    contrast: {value: "{colors.agxes.100}"},
                    fg: {value: "{colors.agxes.700}"},
                    muted: {value: "{colors.agxes.100}"},
                    subtle: {value: "{colors.agxes.200}"},
                    emphasized: {value: "{colors.agxes.300}"},
                    focusRing: {value: "{colors.agxes.500}"},
                },
            },
        },
    },
});

export const system = createSystem(defaultConfig, config);
export default system;
